<script setup lang="ts">
import {
    TooltipArrow,
    TooltipContent,
    TooltipPortal,
    TooltipProvider,
    TooltipRoot,
    TooltipTrigger,
} from 'reka-ui';
import { ref } from 'vue';
import { useHoverSupport } from '../../../composables/hover-support';

const { canHover } = useHoverSupport();

const open = ref(false);

const handleClick = () => {
    if (!canHover.value) {
        open.value = !open.value;
    }
};

const handleBlur = () => {
    if (!canHover.value) {
        open.value = false;
    }
};

const setOpen = (value: boolean) => {
    open.value = value;
};
</script>

<template>
    <TooltipProvider disable-closing-trigger>
        <TooltipRoot
            :open="!canHover ? open : undefined"
            :on-open-change="!canHover ? setOpen : undefined"
        >
            <TooltipTrigger as-child>
                <button
                    class="k-c-label text-gray-600 align-middle"
                    type="button"
                    @click="handleClick"
                    @blur="handleBlur"
                >
                    <slot/>
                </button>
            </TooltipTrigger>
            <TooltipPortal>
                <TooltipContent
                    class="bg-gray-700 text-white max-w-[300px] py-3 p-l rounded-sm"
                    :side-offset="5"
                >
                    <TooltipArrow
                        class="fill-gray-700"
                    />
                    <slot name="description"/>
                </TooltipContent>
            </TooltipPortal>
        </TooltipRoot>
    </TooltipProvider>
</template>
